import { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

import { Text } from '@/decodo/components/atoms/Text';

export type TooltipFlowDirection =
  | 'top-center'
  | 'bottom-center'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export const styleByFlowDirection: { [K in TooltipFlowDirection]: string } = {
  'bottom-left': 'top-full left-0',
  'bottom-right': 'top-full right-0',
  'bottom-center': 'top-full left-1/2 -translate-x-1/2',

  'top-left': 'bottom-full left-0',
  'top-right': 'bottom-full right-0',
  'top-center': 'bottom-full left-1/2 -translate-x-1/2',
};

export type TooltipProps = PropsWithChildren<{
  text: string;
  classNames?: {
    wrapper: string;
    text: string;
    tooltip: string;
    arrow: string;
  };
  flowDirection?: TooltipFlowDirection;
}>;

export const Tooltip = ({
  text,
  children,
  classNames,
  flowDirection = 'top-center',
}: TooltipProps) => {
  const style = styleByFlowDirection[flowDirection];

  return (
    <div className={cn('group relative w-fit', classNames?.wrapper)}>
      {children}
      <div
        className={cn(
          'dark absolute z-50 my-1 hidden min-w-max rounded bg-gray-100 px-3 py-1 group-hover:block',
          style,
          classNames?.tooltip
        )}
      >
        <Text className={cn('text-body-s-medium', classNames?.text)}>
          {text}
        </Text>
      </div>
    </div>
  );
};
